import {
  createPrelaunchStudios,
  editPublicPrelaunchStudioDetail,
  getPrelaunchStudioDetailByUniqueId,
} from '../../../../api/prelaunchOrganizationFormsApi'
import StudioForm from '../../../../components/common/studio-form'
import { convertIPrelaunchStudioToFormValues } from '../../../../helpers/prelaunch-organization-helper'
import translate from '../../../../i18n'
import { PrelaunchStudioCreationFormValues } from '../../../prelaunch-organization-forms-container/share-types'
import { PageHeader } from '@ant-design/pro-components'
import { notification, Space } from 'antd'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

const prelaunchStudioForm = () => {
  const navigate = useNavigate()
  const params = useParams()
  const [uniqueId] = useState<string | undefined>(params?.uniqueId)
  const [organizationName] = useState<string | undefined>(params?.organizationName)
  const [studioId] = useState<string | undefined>(params?.studioId)
  const { pathname } = useLocation()
  const isPublicEdit = pathname.endsWith('/edit')
  const [prelaunchStudioFormData, setPrelaunchStudioFormData] =
    useState<PrelaunchStudioCreationFormValues>()

  useEffect(() => {
    if (studioId && uniqueId) {
      getPrelaunchStudioDetailByUniqueId(uniqueId, Number(studioId)).then(data => {
        setPrelaunchStudioFormData(convertIPrelaunchStudioToFormValues(data))
      })
    }
  }, [studioId, uniqueId])
  const onFinish = (value: PrelaunchStudioCreationFormValues) => {
    if (!uniqueId) {
      return
    }
    const request =
      studioId && isPublicEdit
        ? editPublicPrelaunchStudioDetail(uniqueId, studioId, value)
        : createPrelaunchStudios({
            ...value,
            uniqueId: uniqueId,
          })

    request
      .then(response => {
        if (response) {
          notification.success({
            title: isPublicEdit ? '修改场馆成功' : translate('addStudios.success'),
          })
          navigate(`/public/prelaunch-organization-form/${uniqueId}`)
        }
      })
      .catch(err => {
        notification.error({
          message: isPublicEdit ? '修改场馆失败' : translate('addStudios.error'),
          description: err?.message || translate('networkError'),
        })
      })
  }
  const onBack = () => {
    navigate(-1)
  }

  if (!uniqueId) {
    return null
  }

  return (
    <Space orientation="vertical" style={{ width: '100%' }}>
      <PageHeader
        className="site-page-header"
        onBack={onBack}
        title={organizationName}
        subTitle={translate('addStudios')}
      />
      <StudioForm
        isEdit={false}
        isPublicEdit={isPublicEdit}
        organizationUniqueId={uniqueId}
        onFinish={onFinish}
        formData={prelaunchStudioFormData}
      />
    </Space>
  )
}

export default prelaunchStudioForm
